import axios from "axios";

// Configurar la BaseURL globalmente
axios.defaults.baseURL = "https://wwwa.isepsantafe.net.ar";

// Enviar cookies automáticamente
axios.defaults.withCredentials = true;

// Interceptor de petición (opcional, solo para debug)
axios.interceptors.request.use(
    (config) => {
//         console.log(`[Interceptor] Petición saliente a: ${config.url}`);
        return config;
    },
    (error) => Promise.reject(error)
);

// Interceptor de respuesta
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const esRutaLogin =
            error.config?.url?.endsWith("/") ||
            error.config?.url?.includes("/login") ||
            error.config?.url?.includes("/expedientes/usuariosLoguin");

        if (error.response?.status === 401 && !esRutaLogin) {
            alert("Tu sesión expiró. Volvé a iniciar sesión.");
            window.location.href = "/";
        }

        return Promise.reject(error);
    }
);